import type {
  KycSessionDtoFlow,
  KycSessionDtoFlowStepName,
  KycSessionDtoFlowType,
} from '@/integrations/Immersve/AmethystClient';

interface KycSessionFlowProps {
  type: KycSessionDtoFlowType;
  steps: KycSessionDtoFlowStepName[];
}

export class KycSessionFlow {
  readonly type: KycSessionDtoFlowType;
  readonly steps: KycSessionDtoFlowStepName[];

  constructor(props: KycSessionFlowProps) {
    this.type = props.type;
    this.steps = props.steps;
  }

  static fromApiResponse(kycSessionFlowDto: KycSessionDtoFlow): KycSessionFlow {
    return new KycSessionFlow({
      type: kycSessionFlowDto.type,
      steps: kycSessionFlowDto.steps.map((step) => step.name),
    });
  }

  equals(other: KycSessionFlow): boolean {
    return this.type === other.type && this.steps.join() === other.steps.join();
  }
}
